(function ($) {
    Drupal.behaviors.global = {
        attach() {
            // Accessibility utility classes.
            const $body = $('body');
            $body.on('mousedown', function () {
                $body.addClass('using-mouse');
                $body.removeClass('using-keyboard');

                // Remove accessible animations class.
                $('*.wow').removeClass('accessible-animation');
            });

            $body.on('keydown', function () {
                $body.addClass('using-keyboard');
                $body.removeClass('using-mouse');

                // Make animations accessible.
                $('*.wow').addClass('accessible-animation');
            });

            // get skip to main content a tag.
            // as the only classes on the element are visually-hidden and focusable, we need to grab it by the href
            const skipButton = document.querySelectorAll(
                "a[href='#main-content']",
            );
            if (skipButton.length > 0) {
                skipButton[0].addEventListener('click', function () {
                    // on click, focus the main content
                    const mainContent = document.querySelector('#main-content');
                    mainContent.focus();
                });
            }

            // Page topography pattern background height.
            function refreshPageBackgroundHeight() {
                const $page_bg = $('.page__content__bg');
                const $end_bg = $('.layout--end-bg').last();

                if ($end_bg.length) {
                    const page_bg_top = $page_bg.offset().top;
                    const bg_offset = $end_bg.hasClass('layout--bg-offset');

                    if (bg_offset) {
                        const $last_block = $(
                            '.page__content__block',
                            $end_bg,
                        ).last();
                        const tabletViewport = 768;
                        const isTabletBelow =
                            $(window).width() <= tabletViewport;
                        const isLastTwoCol = $end_bg.hasClass(
                            'layout--full-width-two-col',
                        );

                        if ($last_block.length) {
                            const last_block_top = $last_block.offset().top;
                            const last_block_height = $last_block.height();
                            let offset = 0.85;

                            if (isLastTwoCol && isTabletBelow) {
                                offset = -0.6;
                            } else if (isLastTwoCol) {
                                offset = 0.65;
                            }

                            $page_bg.height(
                                `${
                                    last_block_top -
                                    page_bg_top +
                                    last_block_height * offset
                                }px`,
                            );
                        }
                    } else {
                        const end_bg_top = $end_bg.offset().top;
                        const end_bg_height = $end_bg.height();
                        const end_bg_mb = parseInt(
                            $end_bg.css('marginBottom'),
                            10,
                        );
                        $page_bg.height(
                            `${
                                end_bg_top -
                                page_bg_top +
                                end_bg_height +
                                end_bg_mb / 2
                            }px`,
                        );
                    }
                }
            }

            function resizeFooterBanner() {
                const $footerBanner = $('.OR1__banner');
                if ($footerBanner.length) {
                    $footerBanner.css('margin-top', ($footerBanner[0].getBoundingClientRect().height / 2)*-1)
                }
            }

            // Sets the viewport height into a CSS variable
            function setViewportHeight() {
                // Inner height will compensate for browser UI (toolbars etc). Multiply by 1% to get value suitable for vh
                const vh = window.innerHeight * 0.01;
                // CSS variables are OK here as the concern is for mobile browsers, which will support them
                document.documentElement.style.setProperty('--vh', `${vh}px`);
            }

            function setNavbarHeight() {
                const root = document.documentElement;
                root.style.setProperty('--navbar-height', $('.MO19').height() + 'px');
            }

            function handleAppResize() {
                refreshPageBackgroundHeight();
                setViewportHeight();
                resizeFooterBanner();
                setNavbarHeight();
            }

            setTimeout(handleAppResize, 100);
            $(window).resize(handleAppResize);

            const wow = new WOW({
                boxClass: 'wow', // default
                animateClass: 'animate__animated',
                mobile: true, // default
                live: true, // default
            });
            wow.init();

            $('.layout--ukho').each(function (i, el) {
                // If layout section only has one section overview, decrease vertical spacing below
                if (
                    $(el).find('.page__content__section-overview').length ===
                        1 &&
                    $(el).find('.page__content__block').length === 1
                ) {
                    // Don't apply it on final iteration
                    // i + 1 because indexes start at 0, so length of 1 would check it equals to 0 otherwise
                    if ($('.page__content__section-overview').length != i + 1) {
                        $(el).css('margin-bottom', 0);
                        $(el).css('padding-bottom', 0);
                    }
                }
                if ($(el).find('.OR29').length === 1) {
                    $(el).css('margin-bottom', 0);
                    $(el).css('padding', 0);
                    if ($(el).prev('.layout--ukho').length === 1) {
                        $(el)
                            .find('.OR29-background--top')
                            .css(
                                'background-color',
                                $(el)
                                    .prev('.layout--ukho')
                                    .css('background-color'),
                            );
                    }
                    if ($(el).next('.layout--ukho').length === 1) {
                        $(el)
                            .find('.OR29-background--bottom')
                            .css(
                                'background-color',
                                $(el)
                                    .next('.layout--ukho')
                                    .css('background-color'),
                            );
                    }
                }
            });

            // Leaflet change controls position.
            if (typeof L !== 'undefined') {
                L.Map.addInitHook(function () {
                    if (this.zoomControl) {
                        this.zoomControl.setPosition('topright');
                    }
                });
            }

            // Handling error banner visibility.
            const $message_banner = $body.find('.drupal-messages');
            const $isHomepage = $body.hasClass('path-frontpage');

            if ($isHomepage && $message_banner.length > 0) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $('.drupal-messages').offset().top,
                });
            }

            // GSAP Config
            gsap.config({
                nullTargetWarn: false,
            });
        },
    };
})(jQuery);
